<template>
    <tab-users :association_id="association_id" :is_association_section="true" ref="UsersTab" />
</template>

<script>
import TabUsers from '@/components/tabs/Users.vue';

export default {
    components: {
        TabUsers,
    },
    props: {
        association_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        reload() {
            this.$refs.UsersTab.reloadTable();
        },
    },
};
</script>
